import React, { useState, useContext, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import loginLogo from "../../../assets/loginLogo.png";
import TextField from "@mui/material/TextField";
import searchIcon from "../../../assets/searchIcon.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import exportIcon from "../../../assets/exportIcon.png";
import addIcon from "../../../assets/addIcon.png";
import logOutIcon from "../../../assets/logout.png";
import userIcon from "../../../assets/userIcon.png";
import showDetails from "../../../assets/showDetails.png";
import hideDetails from "../../../assets/hideDetails.png";
import editIcon from "../../../assets/editDetails.png";
import Collapse from "@mui/material/Collapse";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CustomerCareModal from "./CustomerCareModal";
import Tooltip from "@mui/material/Tooltip";
import { AppContext } from "../../../context/crmContext";
import { customerCareTableHeader } from "../../../constants/Constants";
import { useNavigate } from "react-router-dom";
import action from "../action";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import styles from "./CustomerCare.css";
import Button from "@mui/material/Button";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { formatDate } from "../../../common/Common";
import CRMlogo from "../../../assets/CRM.png";
import DateRange from "../../../common/dateTime/DateRange";
import CustomerCareFilters from "./Filters";
import timelineIcon from "../../../assets/timeline.png";
import TimeLine from "../Timeline";
import { customerCareTimeLineHeader } from "../../../constants/Constants";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff867a",
    },
  },
});

const CustomerCareDashboard = () => {
  const [iconsActive, setIconsActive] = useState(0);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const navigate = useNavigate();
  const [userSegment, setUserSegment] = useState("");
  const {
    getOperationSegmentDetails,
    getUserDetails,
    getFilteredCustomerCareListDetails,
    getCustomerCareListAPI,
    getCustomerCareListExcelAPI
  } = action;
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [listingList, setListingList] = useState({});
  const [selectedDetails, setSelectedDetails] = useState({});
  const context = useContext(AppContext);
  const {
    user: { fname, mname, lname, email, id, roles },
    userEmail,
    setSnackBarState,
    setIsLoader,
  } = context;
  const [searchedName, setSearchedName] = useState("");
  const [searchedClinicID, setSearchedClinicID] = useState(null);
  const [searchedDoctorID, setSearchedDoctorID] = useState(null);
  const [openRange, setOpenRange] = useState(false);
  const [filterRange, setFilterRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [isFilterModallOpen, setIsFilterModalOpen] = useState(false);
  const [isViewTimeLine, setIsViewTimeLine] = useState(false);
  const [timelineDetails, setTimeLineDetails] = useState({});
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [filterEmail, setFilterEmail] = useState("");
  const [filterMobile, setFilterMobile] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterTicketId, setFilterTicketId] = useState(null);

  const daterange = {
    inputlabel: "Filter by date",
    btnlable: "Apply",
    btnlableClear: "Clear",
    customStyle: {
      txtStyle: {
        textAlign: "center",
      },
      frmStyle: {
        position: "absolute",
        zIndex: 1,
        top: "15%",
        left: "30%",
      },
    },
    pckrStyle: true,
    handleFilter: (val) => {
      setFilterDateRange(val);
    },
    openRange: openRange,
    setOpenRange: setOpenRange,
    setFilterRange: setFilterRange,
  };

  const setFilterDateRange = (val) => {
    setFilterRange(() => val);
    setOpenRange(() => false);
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      setIsLoader(() => true);
      setPage(() => 1);
      setUserSegment(() => localStorage.getItem("userRole"));
      getUserDetails(localStorage.getItem("accessToken"), userDetails);
      const userRole = localStorage.getItem("roleid");
      // const filteredRole = roles?.filter((e) => e.name === userRole);
      setCurrentUserRole(() => userRole);
      callListingAPI();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    callListingAPI();
  }, [page]);

  const callListingAPI = () => {
    setIsLoader(() => true);
    const payload = {
      page: page,
      size: size,
      startdate: filterRange.startDate,
      enddate: filterRange.endDate,
      doctorid: searchedDoctorID,
      clinicid: searchedClinicID,
      doctorname: searchedName,
      // startdate: dateData.startDate,
      // enddate: dateData.endDate,
      // doctorid: data.doctorId,
      // clinicid: data.clinicId,
      // doctorname: data.name,
      email: filterEmail,
      mobile: filterMobile,
      status: filterStatus,
      ticketId: filterTicketId,
      roleid: localStorage.getItem("roleid"),
    };
    getCustomerCareListAPI(
      payload,
      getCustomerCareData,
      localStorage.getItem("accessToken") || ""
    );
  };

  const userDetails = (details) => {
    if (details?.statusCode === 200 && details?.result) {
      setIsLoader(() => false);
      context.setUser(details?.result?.userDetails);
    } else {
      setIsLoader(() => false);
    }
  };

  const getCustomerCareData = (details) => {
    if (details && details?.statusCode === 200 && details?.result) {
      setIsLoader(() => false);
      setIconsActive(Array(details?.result?.records?.length).fill(false));
      setListingList(() => details?.result);
      setSnackBarState({
        isOpen: true,
        message: details.message,
        statusCode: details.statusCode,
      });
    } else {
      setIsLoader(() => false);
    }
  };

  const setDetalsViewStatus = (index) => {
    const arr = [...iconsActive];
    arr[index] = !arr[index];
    setIconsActive(() => arr);
  };

  const openAddModal = (details) => {
    setSelectedDetails(() => details);
    setIsAddModalOpen(() => true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(() => false);
  };

  const getSearchedValue = (e, key) => {
    if (key === "name") {
      setSearchedName(() => e?.target?.value);
    }
    if (key === "clinicID") {
      setSearchedClinicID(() => e?.target?.value);
    }
    if (key === "doctorID") {
      setSearchedDoctorID(() => e?.target?.value);
    }
  };

  const callFilterSearch = (data, dateData, isPage) => {
    setIsLoader(() => true);
    const searchedData = {
      startDate: dateData.startDate,
      endDate: dateData.endDate,
    };
    setSearchedDoctorID(() => data.doctorId);
    setSearchedClinicID(() => data.clinicId);
    setSearchedName(() => data.name);
    setFilterRange(() => searchedData);
    setFilterEmail(() => data.email);
    setFilterMobile(() => data.phone);
    setFilterStatus(() => data.status);
    setFilterTicketId(() => data.ticketId);
    const payload = {
      page: isPage ? isPage : page,
      size: size,
      startdate: dateData.startDate,
      enddate: dateData.endDate,
      doctorid: data.doctorId,
      clinicid: data.clinicId,
      doctorname: data.name,
      email: data.email,
      mobile: data.phone,
      status: data.status,
      ticketId: data.ticketId,
      roleid: localStorage.getItem("roleid"),
    };
    getFilteredCustomerCareListDetails(payload, getCustomerCareData);
    handleFilterModalClose();
  };

  const filterSearchedData = (data, dateData, isPage) => {
    setPage(() => 1);
    callFilterSearch(data, dateData, isPage);
    // setIsLoader(() => true);
    // const searchedData = {
    //   startDate: dateData.startDate,
    //   endDate: dateData.endDate,
    // };
    // setSearchedDoctorID(() => data.doctorId);
    // setSearchedClinicID(() => data.clinicId);
    // setSearchedName(() => data.name);
    // setFilterRange(() => searchedData);
    // const payload = {
    //   page: page,
    //   size: size,
    //   startdate: dateData.startDate,
    //   enddate: dateData.endDate,
    //   doctorid: data.doctorId,
    //   clinicid: data.clinicId,
    //   doctorname: data.name,
    //   email: data.email,
    //   mobile: data.phone,
    //   status: data.status,
    //   ticketId: data.ticketId,
    //   roleid: localStorage.getItem("roleid"),
    // };
    // getFilteredCustomerCareListDetails(payload, getCustomerCareData);
    // handleFilterModalClose();
  };

  const clearAllFilters = () => {
    const searchedData = {
      startDate: "",
      endDate: "",
    };
    setSearchedDoctorID(() => "");
    setSearchedClinicID(() => "");
    setSearchedName(() => "");
    setFilterRange(() => searchedData);
  };

  const logoutUser = () => {
    navigate("/");
  };

  const getExcelData = () => {
    const payload = {
      page: page,
      size: size,
      startdate: filterRange.startDate,
      enddate: filterRange.endDate,
      doctorid: searchedDoctorID,
      clinicid: searchedClinicID,
      doctorname: searchedName,
      email: filterEmail,
      mobile: filterMobile,
      status: filterStatus,
      ticketId: filterTicketId,
      roleid: localStorage.getItem("roleid"),
      isExport: true
    }
    getCustomerCareListExcelAPI(
      payload,
      getCustomerCareExcelData,
      localStorage.getItem("accessToken") || ""
    );
  }

  const getCustomerCareExcelData = (details) => {
    if (details && details?.statusCode === 200 && details?.result) {
    handleExcelConversion(details.result.records)
    }

  }

  const handleExcelConversion = (data) => {

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "data.xlsx");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleFilterModel = () => {
    setIsFilterModalOpen(() => true);
  };

  const handleFilterModalClose = (data, dat1) => {
    setIsFilterModalOpen(() => false);
  };

  const viewTimeLine = (data) => {
    const details = {
      clinicId: data.clinicid,
      doctorId: data.doctorid,
      doctorname: data.doctorname,
    };
    setTimeLineDetails(() => details);
    setIsViewTimeLine(() => true);
  };

  const closeViewTimeLine = () => {
    setIsViewTimeLine(() => false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container
        fixed
        style={{
          width: "100%",
          height: "100%",
          margin: "0px",
          position: "absolute",
          top: "0",
          left: "0",
          minWidth: "100%",
        }}
      >
        <img
          src={CRMlogo}
          style={{
            position: "absolute",
            top: "89%",
            left: "94%",
            zIndex: 1,
            height: "60px",
          }}
        />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          style={{
            position: "absolute",
            left: "0px",
            height: "10%",
            alignItems: "center",
            boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
          }}
        >
          <img src={loginLogo} style={{ height: "7vh", paddingLeft: "20px" }} />

          <Grid
            style={{
              background: "#f0f1f5",
              marginRight: "4%",
              width: "15%",
              borderRadius: "15px",
              display: "inline-flex",
              alignItems: "center",
            }}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <img
              src={userIcon}
              style={{ height: "40px", width: "40px", marginLeft: "5px" }}
            />
            <span
              style={{
                color: "#7d7d7d",
                width: "50%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {email}
            </span>
            <div
              style={{
                background: "white",
                borderRadius: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "-10px",
                cursor: "pointer",
                boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.16)",
              }}
              onClick={() => logoutUser()}
            >
              <img
                src={logOutIcon}
                style={{ height: "22px", width: "22px", padding: "15px" }}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          style={{
            background: "#f5f5f5",
            position: "absolute",
            left: "0px",
            top: "10%",
            height: "90%",
          }}
        >
          <Grid
            style={{
              position: "relative",
              background: "white",
              height: "94%",
              top: "3%",
              marginLeft: "1%",
              width: "100%",
              marginRight: "1%",
              boxShadow: "4px 4px 8px 0 rgba(0, 0, 0, 0.06)",
              borderRadius: "10px",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              style={{
                padding: "24px",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "Lato",
                  fontSize: "20px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 0.9,
                  letterSpacing: "0.5px",
                  textAlign: "left",
                  color: "#333",
                  paddingLeft: "15px",
                }}
              >
                <b>{`${userSegment}`}</b>
              </span>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "1%",
                }}
              >
                {/* <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Name"
                  sx={{
                    m: 1,
                    width: "20ch",

                    justifyContent: "center",

                    padding: "5px",
                  }}
                  onChange={(e) => getSearchedValue(e, "name")}
                  value={searchedName}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                          paddingTop: "0px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                    sx: {
                      color: "#afafaf",
                      paddingTop: "7px",
                    },
                  }}
                  size="small"
                /> */}
                {/* <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Clinic ID"
                  sx={{
                    m: 1,
                    width: "20ch",

                    justifyContent: "center",

                    padding: "5px",
                  }}
                  onChange={(e) => getSearchedValue(e, "clinicID")}
                  value={searchedClinicID}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                          paddingTop: "0px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                    sx: {
                      color: "#afafaf",
                      paddingTop: "7px",
                    },
                  }}
                  size="small"
                /> */}
                {/* <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Doctor ID"
                  onChange={(e) => getSearchedValue(e, "doctorID")}
                  value={searchedDoctorID}
                  sx={{
                    m: 1,
                    width: "20ch",
                    justifyContent: "center",

                    padding: "5px",
                  }}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                          paddingTop: "0px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                    sx: {
                      color: "#afafaf",
                      paddingTop: "7px",
                    },
                  }}
                  size="small"
                /> */}
                {/* <div style={{ marginRight: "10px" }}>
                  <Button
                    variant="outlined"
                    style={{
                      border: "1px solid #f0f1f5",
                      background: "#f0f1f5",
                      color: "#afafaf",
                      padding: "8px",
                    }}
                    onClick={() => setOpenRange(() => !openRange)}
                  >
                    {filterRange.startDate.length && filterRange.endDate.length
                      ? `${filterRange.startDate} - ${filterRange.endDate}`
                      : "Filter BY Date"}
                  </Button>
                  <DateRange {...daterange} />
                </div> */}
                <Button
                  variant="outlined"
                  style={{
                    border: "1px solid #f0f1f5",
                    background: "#f0f1f5",
                    color: "#afafaf",
                    padding: "8px",
                  }}
                  onClick={() => handleFilterModel()}
                >
                  Filters & Search
                </Button>
                {/* <Button variant="outlined" onClick={() => filterSearchedData()}>
                  Search
                </Button> */}
                <p
                  style={{
                    marginLeft: "15px",
                    marginRight: "15px",
                    display: "flex",
                    color: "#7d7d7d",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => getExcelData()}
                >
                  <img
                    src={exportIcon}
                    style={{
                      height: "16px",
                      width: "16px",
                      marginRight: "5px",
                    }}
                  />
                  Export to Excel
                </p>
                <p
                  style={{
                    marginLeft: "5px",
                    marginRight: "5px",
                    color: "#ff867a",
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => navigate("/add")}
                >
                  <img
                    src={addIcon}
                    style={{
                      height: "16px",
                      width: "16px",
                      marginRight: "5px",
                    }}
                  />
                  Add New
                </p>
              </Grid>
            </Grid>
            <TableContainer
              className={styles.root}
              style={{
                width: "96%",
                marginLeft: "2%",
                borderDadius: "10px",
                overflow: "auto",
                minWidth: "80%",
              }}
            >
              <Table
                className={styles.table}
                style={{
                  backgroundColor: "#ffffff",
                  border: "0.05vw solid rgba(224; 224; 224; 1)",
                }}
                size="medium"
                aria-label="a dense table"
              >
                <TableHead className="tableHead">
                  <TableRow>
                    {customerCareTableHeader.map((header, index) => (
                      <TableCell
                        className={styles.header}
                        style={{
                          color: "white",
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: "bold",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.33",
                          letterSpacing: "normal",
                          textAlign: "left",
                          color: "#FFFFFF",
                          zIndex: "20",
                          width: "10%",
                          maxWidth: "10%",
                        }}
                        key={index}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            <TableContainer
              className={styles.root}
              style={{
                width: "96%",
                marginLeft: "2%",
                maxHeight: "60%",
                overFlow: "auto",
              }}
            >
              <Table
                className={styles.table}
                style={{
                  backgroundColor: "#ffffff",
                  border: "0.05vw solid rgba(224; 224; 224; 1)",
                }}
                size="medium"
                aria-label="a dense table"
                stickyHeader
              >
                {listingList?.records?.length > 0 ? (
                  <TableBody className={styles.tableBody}>
                    {listingList?.records?.map((e, index) => (
                      <>
                        <TableRow
                          className={styles.tableRow}
                          style={{ height: "3rem" }}
                          key={1}
                        >
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip
                              title={e.employeeName}
                              arrow
                              placement="top"
                            >
                              <span>{`${e.fname || ""} ${e.mname || ""} ${
                                e.lname || ""
                              }`}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            {e.doctorid}
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            {e.ticketid}
                          </TableCell>
                          {/* <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            {e.clinicid}
                          </TableCell> */}
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.doctorname} arrow placement="top">
                              <span>{e.doctorname}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.mobile} arrow placement="top">
                              <span>{e.mobile}</span>
                            </Tooltip>
                          </TableCell>
                          {/* <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.city} arrow placement="top">
                              <span>{e.city}</span>
                            </Tooltip>
                          </TableCell> */}
                          {/* <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.email} arrow placement="top">
                              <span>{e.email}</span>
                            </Tooltip>
                          </TableCell> */}
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip
                              title={formatDate(e.issuedate)}
                              arrow
                              placement="top"
                            >
                              <span>{formatDate(e.issuedate)}</span>
                            </Tooltip>
                          </TableCell>
                          {/* <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip
                              title={formatDate(e.starttime)}
                              arrow
                              placement="top"
                            >
                              <span>{formatDate(e.starttime)}</span>
                            </Tooltip>
                          </TableCell>

                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip
                              title={formatDate(e.endtime)}
                              arrow
                              placement="top"
                            >
                              <span>{formatDate(e.endtime)}</span>
                            </Tooltip>
                          </TableCell> */}
                          {/* <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip
                              title={formatDate(e.time)}
                              arrow
                              placement="top"
                            >
                              <span>{formatDate(e.time)}</span>
                            </Tooltip>
                          </TableCell> */}
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.remarks} arrow placement="top">
                              <span>{e.remarks}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            <Tooltip title={e.status} arrow placement="top">
                              <span
                                style={
                                  e.status === "Open"
                                    ? { color: "#6ed67f" }
                                    : e.status === "Cancelled"
                                    ? { color: "#6fdcff" }
                                    : e.status === "Pending"
                                    ? { color: "#f4be4f" }
                                    : e.status === "Tech Team"
                                    ? { color: "#ba8eff" }
                                    : e.status === "Resolved"
                                    ? { color: "#ff867a" }
                                    : { color: "gray" }
                                }
                              >
                                <li>{e.status}</li>
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                              color: "#fe867a",
                            }}
                          >
                            <p
                              style={{ display: "flex" }}
                              onClick={() => viewTimeLine(e)}
                            >
                              <img
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "5px",
                                }}
                                src={timelineIcon}
                              />
                              View Timeline
                            </p>
                          </TableCell>
                          <TableCell
                            className={styles.body}
                            style={{
                              fontFamily: "Lato",
                              fontSize: "0.64",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#2e2e2e",
                              width: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                            }}
                          >
                            {iconsActive[index] ? (
                              <span
                                style={{
                                  padding: "7px",

                                  borderRadius: "5px",
                                  backgroundColor: "#ff867a33",
                                }}
                              >
                                <img
                                  src={showDetails}
                                  style={{ height: "14px", width: "14px" }}
                                  onClick={() => setDetalsViewStatus(index)}
                                />
                              </span>
                            ) : (
                              <span
                                style={{
                                  padding: "7px",

                                  borderRadius: "5px",
                                  backgroundColor: "white",
                                }}
                              >
                                <img
                                  src={hideDetails}
                                  style={{ height: "14px", width: "14px" }}
                                  onClick={() => setDetalsViewStatus(index)}
                                />
                              </span>
                            )}
                            {e.status !== "Resolved" && (
                              <img
                                src={editIcon}
                                style={{
                                  height: "14px",
                                  width: "14px",
                                  paddingLeft: "10px",
                                }}
                                onClick={() => openAddModal(e)}
                              />
                            )}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            style={{
                              paddingBottom: 0,
                              paddingTop: 0,
                              paddingLeft: 0,
                              paddingRight: 0,
                            }}
                            colSpan={10}
                          >
                            <Collapse
                              in={iconsActive[index]}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Grid
                                style={{
                                  background: "#f3f3f3",
                                  height: "100px",
                                  paddingLeft: "50px",
                                  paddingRight: "50px",

                                  fontSize: "12px",
                                  fontWeight: "normal",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: 1.25,
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#7d7d7d",
                                  justifyContent: "space-between",
                                }}
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Grid
                                  style={{
                                    width: "100%",
                                    justifyContent: "space-evenly",
                                    display: "flex",
                                  }}
                                >
                                  <span style={{ fontSize: "14px" }}>
                                    Service Count :{" "}
                                    <b>{e.servicecount || "-"}</b>
                                  </span>
                                  {/* <Tooltip
                                  title={e.linkshared}
                                  arrow
                                  placement="top"
                                >
                                  <div
                                    className={styles.collapsableTable}
                                    style={{
                                      width: "200px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "200px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Link shared :
                                    <Typography
                                      className={styles.collapsableTable}
                                      style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "200px",
                                        color: "#7D7D7D",
                                        fontSize: "14px",
                                      }}
                                      component={Link}
                                      to={e.linkshared}
                                    >
                                      <b>{e.linkshared}</b>
                                    </Typography>
                                  </div>
                                </Tooltip> */}

                                  <span style={{ fontSize: "14px" }}>
                                    Total Prescription :{" "}
                                    <b>{e.totalprescriptions || "-"}</b>
                                  </span>

                                  <span style={{ fontSize: "14px" }}>
                                    Account Creation Date :{" "}
                                    <b>{e.account_creation_date || "-"}</b>
                                  </span>

                                  <span style={{ fontSize: "14px" }}>
                                    Total Appointments :{" "}
                                    <b>{e.totalappointments || "-"}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Last Prescription :{" "}
                                    <b>{formatDate(e.lastprescriptiondate)}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Last Appointment :{" "}
                                    <b>{formatDate(e.lastappointmentdate)}</b>
                                  </span>
                                </Grid>
                                <Grid
                                  style={{
                                    width: "100%",
                                    justifyContent: "space-evenly",
                                    display: "flex",
                                  }}
                                >
                                  <span style={{ fontSize: "14px" }}>
                                    City: <b>{e.city || "-"}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Email : <b>{e.email || "-"}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Clinic ID : <b>{e.clinicid || "-"}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Start Time :{" "}
                                    <b>{formatDate(e.starttime)}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    End Time : <b>{formatDate(e.endtime)}</b>
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    Mode Of Communication :{" "}
                                    <b>{e.mode || "-"}</b>
                                  </span>
                                </Grid>
                              </Grid>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10vh",
                      fontWeight: "bold",
                    }}
                  >
                    No Data Available
                  </p>
                )}
              </Table>
            </TableContainer>
            <div style={{ paddingTop: "40px", paddingLeft: "30px" }}>
              <ThemeProvider theme={theme}>
                <Pagination
                  count={Math.ceil(listingList?.totalRecords / size )}
                  color="primary"
                  style={{ color: "white" }}
                  onChange={handleChangePage}
                />
              </ThemeProvider>
            </div>
          </Grid>
        </Grid>
        {isAddModalOpen && (
          <CustomerCareModal
            isAddModalOpen={isAddModalOpen}
            closeAddModal={closeAddModal}
            selectedDetails={selectedDetails}
            callListingAPI={callListingAPI}
            headerLabel={"Edit Details"}
          />
        )}
        {isFilterModallOpen && (
          <CustomerCareFilters
            open={isFilterModallOpen}
            handleFilterModalClose={handleFilterModalClose}
            filterSearchedData={filterSearchedData}
            selectedFilterRange={filterRange}
            clearAllFilters={clearAllFilters}
          />
        )}
        {isViewTimeLine && (
          <TimeLine
            isViewTimeLine={isViewTimeLine}
            closeViewTimeLine={closeViewTimeLine}
            timelineDetails={timelineDetails}
            tableHeader={customerCareTimeLineHeader}
          />
        )}
      </Container>
    </ThemeProvider>
  );
};

export default CustomerCareDashboard;
